import { VpnPriceComparisonWrapper } from "@components/layouts";
import { GetServerSideProps } from "next";
import React, { ReactElement } from "react";
import MainSection from "@components/vpnpricecomparison/mainSection";
import ContactUs from "@components/vpnpricecomparison/contactUs";
import { getPageProps } from "@services/initial-calls";

export default function ContactUsPage(): ReactElement {
    return (
        <VpnPriceComparisonWrapper>
            <MainSection contactUs />
            <ContactUs />
        </VpnPriceComparisonWrapper>
    );
}

export const getServerSideProps: GetServerSideProps = async (context) => {
    return await getPageProps(context, "home", {
        pageTitle: "Contact Us",
        pageDescription: "We are open to discuss potential opportunities.",
    });
};
